const cloudinaryVideo = document.querySelector('.video-desktop-cloudinary');
const cl = new cloudinary.Cloudinary({cloud_name: "mcdeeez", secure: true});
cloudinaryVideo.innerHTML = cl.videoTag('Frond/frond-shop-video--compressed', {autoplay: true, loop: true, muted: true, playsinline: true}).toHtml();


const video = document.querySelector('#shop-video video');
const muteBtn = document.getElementById('video-mute');

if(video.muted == false) {
	muteBtn.classList.add('unmuted');
}

muteBtn.addEventListener('click', function(){

	if(video.muted == true) {
		video.muted = false;
		this.classList.add('unmuted');
	} else {
		video.muted = true;
		this.classList.remove('unmuted');
	}
});